import React from 'react';

const Portlet = ({ className = '', children, ...props }) => (
  <div className={`portlet rounded ${className}`} {...props}>
    {children}
  </div>
);

export default Portlet;
